export default "__VITE_ASSET__DVGILdn4__"